/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import type {
  BaseDiagramProps,
  DiagramNodeData,
  DiagramLinkData,
  DiagramLayoutOutput
} from './diagram.types';
import { TrackResizeContainer } from '#UNSAFE_TrackResizeContainer';
import { dimensionStyle } from './themes/DiagramStyles.css';
import { BaseDiagramWithDimensions } from './BaseDiagramWithDimensions';

/**
 * Diagrams are used to display a set of nodes and the links between them.
 */
export function BaseDiagram<
  K1 extends string | number,
  K2 extends string | number,
  D1 extends DiagramNodeData<K1, D1>,
  D2 extends DiagramLinkData<K2, K1>,
  L extends DiagramLayoutOutput<K1, K2>
>({ width, height, ...otherProps }: BaseDiagramProps<K1, K2, D1, D2, L>) {
  return otherProps.nodes && otherProps.nodes.length > 0 ? (
    <TrackResizeContainer width={width} height={height} class={dimensionStyle}>
      {(width, height) => (
        <BaseDiagramWithDimensions width={width} height={height} {...otherProps} />
      )}
    </TrackResizeContainer>
  ) : null;
}
